import React, {PropsWithChildren, Fragment, useEffect} from "react";
import {useLocation, useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {
	isNeedToRegisterForYear,
	isAdditionalInformationRequired,
} from "modules/selectors";

export const HOCReturningUser: React.FC<PropsWithChildren<{}>> = ({
	children,
}) => {
	const location = useLocation();
	const history = useHistory();
	const isNeedToReActivate = useSelector(isNeedToRegisterForYear);
	const isNeedToRegisterForGame = useSelector(
		isAdditionalInformationRequired
	);

	const isRouteForGame = location.pathname === "/register-for-game";
	const isRouteReturningUser = location.pathname === "/returning-user";

	useEffect(() => {
		if (isNeedToReActivate && !isRouteReturningUser) {
			history.push("/returning-user");
		}
	}, [isNeedToReActivate, isRouteReturningUser, history]);

	useEffect(() => {
		if (isNeedToRegisterForGame && !isRouteForGame && !isNeedToReActivate) {
			history.push("/register-for-game");
		}
	}, [isNeedToRegisterForGame, isRouteForGame, history, isNeedToReActivate]);

	return <Fragment>{children}</Fragment>;
};
